/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/People';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PeopleIcon = withMuiAdapter(Base, 'People');
